<template>
  <a-modal title="" :visible="visible" :closable="false" :width="280" :footer="null" @ok="handleOk" @cancel="handleCancel" class="enquiry-modal">
    <div class="affirm-popup-box">
      <div class="affirm-popup-image">
        <img src="@/assets/image/tishi.png" alt="" class="image">
      </div>
      <div class="affirm-popup-content">
        <div class="content">
          <span>您是否确认是否提交此单？</span>
        </div>
      </div>
      <div class="affirm-popup-btn">
        <div class="btn-cancel" id="popup-cancel" @click="handleCancel">
          <span>取消</span>
        </div>
        <div class="btn-affirm" id="popup-affirm" @click="handleOk">
          <span>确认</span>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data () {
    return {
      visible: false
    };
  },
  methods: {
    showModal () {
      this.visible = true
    },
    handleOk (e) {
      this.visible = false
      this.$emit('handleOk')
    },
    handleCancel (e) {
      this.visible = false
      this.$emit('handleCancel')
    },
  },
};
</script>
<style lang="scss">
.enquiry-modal {
  .affirm-popup-content {
    width: 100%;
    height: 50px;
    text-align: center;
    margin-top: 40px;
  }

  .affirm-popup-content .content {
    padding: 0 25px;
  }

  .affirm-popup-btn {
    width: 280px;
    height: 45px;
    border-top: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .btn-cancel {
    width: 139px;
    height: 45px;
    border-right: 1px solid #ebebeb;
    line-height: 45px;
    text-align: center;
  }

  .btn-affirm {
    width: 140px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #f76f14;
  }
  .affirm-popup-box {
    width: 280px;
    height: 160px;
    background-color: #ffffff;
    border-radius: 6px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    top: 50%;
    .affirm-popup-image {
      position: absolute;
      top: -20px;
      left: 110px;
      .image {
        width: 60px;
        height: 60px;
      }
    }
  }
}
.ant-modal-body {
  padding: 0;
}
</style>
